import ClinicPro from './Components/ClinicPro/ClinicPro.js';

function App() {
  return (
    <div className="App">
      <ClinicPro />
    </div>
  );
}

export default App;
